import Masthead from "@/components/Masthead";
import CoverStory from "@/components/CoverStory";
import Ticker from "@/components/Ticker";
import Practice from "@/components/Practice";
import FeatureStories from "@/components/FeatureStories";
import EditorsLetter from "@/components/EditorsLetter";
import MarketplaceIntro from "@/components/MarketplaceIntro";
import TwoDoors from "@/components/TwoDoors";
import ContactDesk from "@/components/ContactDesk";
import Colophon from "@/components/Colophon";

export default function Home() {
  return (
    <main id="top" data-testid="home-page" className="relative bg-white text-[#16180F]">
      <Masthead />
      <Practice />
      <CoverStory />
      <Ticker />
      <FeatureStories />
      <EditorsLetter />
      <MarketplaceIntro />
      <TwoDoors />
      <ContactDesk />
      <Colophon />
    </main>
  );
}
